import React from "react";
import './c40_photo_carousel.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";

class PhotoCarousel extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0,
            updateCount: 0
        }
    };

    componentRender(data) {
        const settings = {
            dots: true,
            infinite: true,
            centerMode: true,
            centerPadding: "70px",
            speed: 500,
            swipeToSlide: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            afterChange: (index) => this.setState(state => ({ slideIndex: state.updateCount + (index + 0) })),
            beforeChange: (current, next) => this.setState({ slideIndex: next })
        };

        return (
            <div id={!isMobileOnly ? 'photo-carousel' : 'photo-carousel-mob'}>
                <div className="photo-carousel-container">
                    <div className="text-container">
                        <div className="photo-carousel-text" {...insertHtml(data.slides[this.state.slideIndex].title)} />
                        <div className="photo-carousel-subtitle" {...insertHtml(data.slides[this.state.slideIndex].text)} />
                        <div className="photo-carousel-button">
                            <button className="photo-carousel-instagram-button">
                                <a href={data.slides[this.state.slideIndex].link_white}>{data.slides[this.state.slideIndex].cat_white}</a>
                            </button>
                            <button className="photo-carousel-facebook-button">
                                <a href={data.slides[this.state.slideIndex].link_blue}>{data.slides[this.state.slideIndex].cat_blue}</a>
                            </button>
                        </div>
                    </div>
                    <div className="slider-container">
                        <Slider {...settings}>
                            {data.slides.map((img, index) => (
                                <img key={index} src={img.img} alt={img.alt}/>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
}

export default PhotoCarousel;
